export interface Category {
  key: string;
  name: string;
  icon: string;
  desc: string;
}

export const categories: Category[] = [
  {
    key: '电影',
    name: '电影',
    icon: 'ri-film-line',
    desc: '院线热映、口碑佳作与经典片单，覆盖科幻、悬疑、剧情、爱情等多种类型。',
  },
  {
    key: '电视剧',
    name: '电视剧',
    icon: 'ri-live-line',
    desc: '年代、都市、古装、悬疑等热门剧集，追剧不掉队，更新早知道。',
  },
  {
    key: '综艺',
    name: '综艺',
    icon: 'ri-mic-line',
    desc: '美食、旅行、音乐等热门综艺节目，轻松解压，欢乐不断。',
  },
  {
    key: '动漫',
    name: '动漫',
    icon: 'ri-sword-line',
    desc: '热血、治愈、国风与日系新番，动画迷的专属片单。',
  },
];

export const regionOptions: string[] = ['不限', '大陆', '香港', '欧美', '日韩'];

export const yearOptions: string[] = ['不限', '近一年', '近三年', '2020年前'];

export const sortOptions: string[] = ['最新', '最热'];